<template>
  <kst-section collapsible collapsed
    :title="sectionTitle"
    :help-collapsed="sectionHelp"
  >
    <kst-output field="IsNeedDelivery" :data="invoiceData" :catalog="Catalog"/>
    <template v-if="invoiceData.IsNeedDelivery">
      <kst-output field="DeliveryDate" :data="invoiceData" :catalog="Catalog"/>
    </template>
  </kst-section>
</template>

<script>
import Catalog from "../InvCatalog.js";
import Info from "../InvInfo.js";
import Model from "../InvModel.js";

export default {
  props: {
    invoiceData: Object
  },
  data: () => ({
    Catalog: Catalog
  }),
  computed: {
    sectionTitle() {
      return Info.Section.Delivery.Title;
    },
    sectionHelp() {
      return Model.getDeliverySectionHelp(this.invoiceData);
    }
  }
}
</script>